import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { saveToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, object = user
  const [authOpen, setAuthOpen] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return; // AuthCallback handles it
    checkAuth();
  }, [checkAuth]);

  const adopt = (data) => { if (data?.token) saveToken(data.token); const { token, ...u } = data || {}; setUser(u); };
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    adopt(data);
  };
  const register = async (email, password, username) => {
    const { data } = await api.post("/auth/register", { email, password, username });
    adopt(data);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } finally { saveToken(null); setUser(false); }
  };

  return (
    <AuthCtx.Provider
      value={{ user, setUser: adopt, checkAuth, login, register, logout, authOpen, setAuthOpen, openAuth: () => setAuthOpen(true) }}
    >
      {children}
    </AuthCtx.Provider>
  );
}
